const autoplay = {
  props: {
    autoplay: {
      type: Boolean,
      default: true,
    },
    autoplayTimeout: {
      type: Number,
      default: 2000,
    },
    autoplayHoverPause: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      autoplayInterval: null,
    };
  },
  destroyed() {
    this.$el.removeEventListener('mouseenter', this.pauseAutoplay);
    this.$el.removeEventListener('mouseleave', this.startAutoplay);
  },
  methods: {
    pauseAutoplay() {
      if (this.autoplayInterval) {
        this.autoplayInterval = clearInterval(this.autoplayInterval);
      }
    },
    startAutoplay() {
      if (this.autoplay) {
        this.autoplayInterval = setInterval(this.advancePage, this.autoplayTimeout);
      }
    },
  },
  mounted() {
    if (this.autoplayHoverPause) {
      this.$el.addEventListener('mouseenter', this.pauseAutoplay);
      this.$el.addEventListener('mouseleave', this.startAutoplay);
    }

    this.startAutoplay();
  },
};

export default autoplay;
